import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectLandArea = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('site')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
